<template>
  <div>
    <div class="su-top box-sizing">
      <div  class="flow_tips_buy">
        <router-link to="/tabs/flowRecharge"><font>温馨提示：购买任意访问包送VIP，拥有高级功能管理，数据统计等</font></router-link>
      </div>
      <div class="su-item" style="margin-top: 20px;">
        <span class="lab">活码名称：</span>
        <span class="opt">
          <span class="opt"><el-input class="inp" placeholder="请输入活码名称" v-model="livecodename" clearable></el-input></span>
        </span>
        <span class="lab">时间：</span>
        <span class="opt">
          <el-date-picker
              v-model="timeGroup"
              type="daterange"
              unlink-panels
              value-format="timestamp"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :editable="false"
              :picker-options="pickerOptions"
              :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </span>
      </div>
      <div class="su-item">
        <span class="lab">关键词：</span>
        <span class="opt"><el-input class="inp" placeholder="请输入短链接域名或备注" v-model="keyword" clearable></el-input></span>
        <span class="lab"></span>
        <span class="opt"><el-button type="primary" @click="getUrlList">搜索</el-button></span>
      </div>
      <div class="btn-features">
        <el-button type="success" @click="$router.push('/tabs/liveCode')" style="font-weight: bolder;">+创建活码</el-button>
        <el-button type="primary" @click="feeDialog=true" style="font-weight: bolder;"><em class="iconfont icon-dwzRectangleCopy6"></em>收费标准</el-button>
        <el-popconfirm title="确定删除选中的链接吗？删除后不可恢复！" @confirm="delLinks()" style="margin-left: 10px">
          <el-button type="danger" slot="reference">删除选中</el-button>
        </el-popconfirm>


      </div>
    </div>
    <div class="su-mid box-sizing">
      <el-table v-loading="isLoading3" :data="tableData" empty-text="暂无数据" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="42"></el-table-column>
        <el-table-column label="添加日期" width="110">
          <template slot-scope="scope">
            <div class="lim text-align exc_color" v-if="scope.row.is_exclusive">
              <i class="iconfont iconhuiyuanjulebu"></i>专属域名
            </div>
            <div class="lim">{{ scope.row.create_time }}</div>
          </template>
        </el-table-column>
        <el-table-column label="网址">
          <template slot-scope="scope">
            <div class="lim">
              <div class="l">
                <span>名称：</span>
                <a class="links" :href="scope.row.new_url" target="_blank">{{ scope.row.live_code_name }}</a>
              </div>
              <div class="r">
                <el-link type="primary" @click="amendName=true,id=scope.row.id">替换</el-link>
              </div>
            </div>
            <div class="lim">
              <div class="l">
                <span>短：</span>
                <a class="links" :href="scope.row.new_url" target="_blank">{{ scope.row.new_url }}</a>
              </div>
              <div class="r">
                <el-link type="primary" @click="copyUrl(scope.row.new_url)">复制</el-link>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="二维码" width="75" class-name="text-align">
          <template slot-scope="scope">
            <el-tooltip effect="dark" content="点击查看二维码" placement="top">
              <i class="icon iconfont iconerweima" @click="showQrCode(scope.row.new_url)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="pv" label="PV" width="75" class-name="text-align"></el-table-column>
        <el-table-column prop="uv" label="UV" width="75" class-name="text-align"></el-table-column>
        <el-table-column prop="ip" label="IP" width="75" class-name="text-align"></el-table-column>
<!--        <el-table-column label="分类" width="120" class-name="text-align">-->
<!--          <template slot-scope="scope">-->
<!--            <span v-if="scope.row.labelName" class="class"-->
<!--                  @click="editClass(scope.row.id)">{{ scope.row.labelName }}</span>-->
<!--            <i v-else class="class icon el-icon-edit-outline" @click="editClass(scope.row.id)"></i>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <!--      修改活码名称-->

        <el-table-column label="备注" width="120" class-name="text-align">
          <template slot-scope="scope">
            <el-tooltip effect="dark" content="点击修改备注" placement="top">
              <div class="link-mark" @click="editMark(scope.row)">{{ scope.row.mark }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="148">
          <template slot-scope="scope">
            <div class="text-center">
              <router-link class="opt-link" :to="'/tabs/MyliveCode/'+scope.row.id">管理</router-link>
<!--              <router-link class="opt-link" :to="'/tabs/advanced/'+scope.row.id">高级功能</router-link>-->
              <router-link class="opt-link" :to="'/tabs/channel/'+scope.row.id">渠道管理</router-link>
              <a class="opt-link" :href="'/statistics/'+scope.row.id" target="_blank">数据统计</a>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagebar" v-show="total>0">
        <el-pagination background layout="total, prev, pager, next, jumper" :total="total"
                       @current-change="handleCurrentPage"></el-pagination>
      </div>
    </div>




    <el-dialog title="修改活码名称" :visible.sync="amendName" center width="400px">
            <span>
                <el-input v-model="nameval" clearable placeholder="请输入新名称"></el-input>
            </span>
      <span slot="footer">
                <el-button @click="amendName=false">取消</el-button>
                <el-button type="primary" @click="modificationNmae">确定</el-button>
            </span>
    </el-dialog>
    <!--查看二维码-->
    <el-dialog title="查看二维码" :visible.sync="qrCodeDialog" center :destroy-on-close="true" :modal-append-to-body="false"
               width="400px">
            <span>
                <div class="link-qr-code" ref="qrCodeDiv"></div>
            </span>
      <span slot="footer">
                <el-button type="primary" @click="savePic">下载二维码</el-button>
            </span>
    </el-dialog>

    <!--域名备注-->
    <el-dialog title="设置备注" :visible.sync="markDialog" center width="400px">
            <span>
                <el-input v-model="urlMark" clearable maxlength="20" placeholder="请输入备注"></el-input>
            </span>
      <span slot="footer">
                <el-button @click="markDialog=false">取消</el-button>
                <el-button type="primary" @click="saveMark">确定</el-button>
            </span>
    </el-dialog>
    <!--域名备注-->
    <el-dialog title="收费标准" :visible.sync="feeDialog" center width="400px">
            <span>
                 因为高昂的服务器成本，我们是付费服务，<br>活码需要购买访问包，每次扫码或打开链接消耗1个点。 <br><br>
                 100元/1万点  <br>
                 500元/12万点+送1个专属域名 <br>
                 5000元/1年无限点+送5个专属域名 <br>
                 10000元/永久无限点+送5个专属域名+送永久vip <br>
              <br>
              <font color="red">请购买访问包使用本产品，对于免费用户会有跳转到广告的概率 。谢谢支持！</font>
            </span>
      <span slot="footer">
                <el-button @click="feeDialog=false">取消</el-button>
                <el-button type="primary" @click="$router.push('/tabs/flowRecharge')">去购买</el-button>
            </span>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2';

export default {
  name: "ShortUrlList",
  data() {
    return {
      id:0,
      isVip: false,
      livecodename: "",
      expUrlClass: "",
      keyword: "",
      nameval: '',
      total: 0,
      expTotal: 0,
      currentPage: 1,
      expCurrentPage: 1,
      timeGroup: [],
      expTimeGroup: [],
      classOptions: [],
      excOptions: [],
      tableData: [],
      exportData: [],
      multipleSelection: [],
      qrCodeDialog: false,
      classDialog: false,
      feeDialog:false,
      oldDialog:false,
      markDialog: false,
      exportDialog: false,
      replaceDialog: false,
      amendName:false,
      selClassID: "",
      url:"",
      selUrlID: "",
      btnLoading: false,
      urlMark: "",
      exclusive: "",
      isLoad: true,
      isLoads: false,
      isLoading1: false,
      isLoading2: false,
      isLoading3: false,
      isLoading4: false,
      isLoading5: false,
      orgUrl: "",
      newUrl: "",
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    }
  },
  mounted() {
    const token = this.$storeLocal.get('token');
    const user_info = this.$storeLocal.get('userInfo');
    const times = Date.parse(new Date()) / 1000;

    if (token !== null && token !== '' && token !== undefined) {
      if (user_info.expire_date > times) {
        this.isVip = true;
      }
    }
    this.getUrlList();
  },
  methods: {
    async getUrlList() {
      this.isLoading3 = true;
      let start = 0;
      let end = 0;
      if (this.timeGroup === null) this.timeGroup = [];
      if (this.timeGroup.length === 2) {
        start = this.timeGroup[0];
        end = this.timeGroup[1];
      }
      const getData = {
        start: Number(start / 1000),
        end: Number(end / 1000),
        keyword: this.keyword,
        livecodename: this.livecodename,
        p: this.currentPage,
      };
      const {ret, data} = await this.$api.livecode.liveCodelist(getData);
      this.isLoading3 = false;
      if (ret === 1000) {
        this.total = Number(data.total);
        this.tableData = data.list;
      }
    },
    //修改活码名称
    async modificationNmae() {
      if (this.nameval === "") {
        this.$message.error('请输入新名称！');
        return;
      }
      const getData = {
        nameval: this.nameval,
        id: this.id
      };
      const {ret} = await this.$api.livecode.amendNmae(getData);
      if (ret === 1000) {
        this.getUrlList();
        this.amendName = false;
        this.nameval = '';
        this.id = 0;
        this.$message.success('设置成功');
      }
    },

    async saveMark() {
      if (this.selUrlID === "") {
        this.$message.error('出错了！刷新后试试看');
        return;
      }
      const getData = {
        ids: this.selUrlID,
        mark: this.urlMark,
      };
      const {ret} = await this.$api.shortUrl.saveMark(getData);
      if (ret === 1000) {
        await this.getUrlList();
        this.selUrlID = "";
        this.markDialog = false;
        this.$message.success('保存成功！');
      }
    },
    async delLinks() {
      console.log('1111');
      const ids = this.selUrlID;
      console.log(ids);
      if (ids === '') {
        this.$message.error('请选择要删除的链接！');
        return;
      }
      const {ret} = await this.$api.shortUrl.delLink({ids: ids});
      if (ret === 1000) {
        this.$message.success('删除成功');
        this.selUrlID = "";
        await this.getUrlList();
      }
    },
    async getDomainList(val) {
      if (!val) return;
      if (this.isLoads) return;
      this.isLoading1 = true;
      const {ret, data} = await this.$api.exclusive.getUserList();
      this.isLoading1 = false;
      if (ret === 1000) {
        this.isLoads = true;
        this.excOptions = data.list;
      }
    },
    handleSelectionChange(val) {
      if (val.length === 0) {
        return;
      }
      let ids = "";
      for (const item of val) {
        ids += item.id + ",";
      }
      ids = ids.substr(0, ids.length - 1);
      this.selUrlID = ids;
    },
    handleCurrentPage(val) {
      this.currentPage = val;
      this.getUrlList();
    },
    handleExpCurrentPage(val) {
      this.expCurrentPage = val;
      this.getExportList();
    },
    handleExportData() {
      this.exportDialog = true;
      if (this.isLoad) {
        this.isLoad = false;
        this.getExportList();
      }
    },
    editClass(id) {
      this.classDialog = true;
      this.selUrlID = id;
    },
    editMark(item) {
      this.markDialog = true;
      this.selUrlID = item.id;
      this.urlMark = item.mark;
    },
    copyUrl(txt) {
      const msg = this.$message;
      if (txt === '') {
        msg.error('复制失败！');
      }
      this.$copyText(txt).then(function (e) {
        console.log(e);
        msg.success('复制成功');
      }, function (e) {
        console.log(e);
        msg.error('复制失败！');
      });
    },
    showQrCode(txt) {
      if (txt === '') {
        this.$message.error('出错了！刷新试试看！');
        return;
      }
      this.qrCodeDialog = true;
      const $this = this;
      setTimeout(function () {
        $this.$refs.qrCodeDiv.innerHTML = '';
        new QRCode($this.$refs.qrCodeDiv, {
          text: txt,
          width: 200,
          height: 200,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
        });
      }, 100);
    },
    savePic() {
      let myQrCode = this.$refs.qrCodeDiv.getElementsByTagName('canvas');
      let a = document.createElement('a');
      a.href = myQrCode[0].toDataURL('image/png');
      a.download = 'linkQrCode';
      a.click();
    },
    saveExcel(url) {
      if (url === '') return;
      let a = document.createElement('a');
      a.href = url;
      a.download = 'linkExcel';
      a.click();
    }
  }
}
</script>

<style scoped>
.su-top {
  width: 100%;
  height: auto;
  padding: 20px;
}

.su-top .su-item {
  width: 100%;
  height: 40px;
  color: #666666;
  margin-bottom: 10px;
}

.su-top .su-item .lab {
  display: inline-block;
  width: 80px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: right;
  margin-right: 10px;
  vertical-align: top;
}

.su-top .su-item .opt {
  display: inline-block;
  width: 350px;
  height: 40px;
  vertical-align: top;
}

.su-top .su-item .inp {
  width: 350px;
}

.su-top .btn-features {
  width: 100%;
  height: 40px;
  margin-top: 30px;
}

.su-mid {
  width: 100%;
  padding: 0 20px;
}

.su-mid .lim {
  width: 100%;
  height: 24px;
}

.su-mid .lim .l {
  display: inline-block;
  width: 242px;
  height: 24px;
  overflow: hidden;
  vertical-align: top;
}

.su-mid .lim .l .links {
  display: inline-block;
  /*width: 214px;*/
  height: 24px;
  color: #409EFF;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: top;
}

.su-mid .lim .l .links:hover {
  color: #66b1ff;
  text-decoration: underline;
}

.su-mid .lim .r {
  display: inline-block;
  width: 28px;
  height: 24px;
  cursor: pointer;
  margin-left: 10px;
  vertical-align: top;
}

.su-mid .icon {
  cursor: pointer;
  font-size: 28px;
}

.su-mid .icon:hover {
  color: #409EFF;
}

.su-mid .class {
  color: #409EFF;
  cursor: pointer;
}

.pagebar {
  width: 100%;
  height: 52px;
  margin-top: 20px;
}

.link-qr-code {
  width: 200px;
  height: 200px;
  margin: 0 auto;
}

.opt-link {
  color: #409EFF;
  margin-right: 5px;
  white-space: nowrap;
}

.link-mark {
  width: 100px;
  min-height: 23px;
}

.exp_box {
  width: 100%;
}

.exp_box .exp_title {
  width: 100%;
  height: auto;
  font-size: 14px;
  margin-bottom: 20px;
}

.exp_box .exp_head {
  width: 100%;
  height: 40px;
  margin-bottom: 20px;
}

.exp_box .exp_head .lab {
  display: inline-block;
  width: auto;
  height: 40px;
  line-height: 40px;
  margin: 0 5px;
  vertical-align: top;
}

.exp_box .exp_head .sel {
  width: 160px;
}

.exp_box .exp_head .inp {
  margin-left: 10px;
}

.replace {
  width: 100%;
  height: auto;
}

.replace .item {
  width: 100%;
  height: 40px;
  line-height: 40px;
}

.replace .item .l {
  display: inline-block;
  width: 60px;
  height: 40px;
  vertical-align: top;
}

.replace .item .r {
  display: inline-block;
  width: 290px;
  height: 40px;
  vertical-align: top;
}

.exc_color {
  color: #f6ab16 !important;
}
</style>
